/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: types.ts
 * Class: types.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetModResponse, ModTagGroup } from '@c/landingpage/modpack/types';
import { MutationRequestState } from '../types';

export interface ModOffsetLimit {
  limit: number;
  offset: number;
}

export interface Game {
  id: number;
  name: string;
  key: string;
  platform: string;
  unit_multiplier: number;
  min_units: number;
  max_units: number;
  release_date: string;
}

export interface GameState {
  game: MutationRequestState<Game, void>;
  mods: MutationRequestState<GetModResponse, void>;
  groupedMods: MutationRequestState<Array<ModTagGroup>, void>
  extensions: MutationRequestState<Array<AddonExtension>, void>
  activeModspaceExtension: MutationRequestState<ActiveAddonExtension | null, void>
  error: boolean;
  worker: Worker;
}

export interface AbstractAddonExtension {
  addonUnits: number;
}

export interface AddonExtension extends AbstractAddonExtension{
  addonUnits: number;
  amountToPayNowDuration: number;
  amountToPayNow: {
    amount: string;
    curreny: string;
  },
  amountToPayNowFormatted: string;
  fullPrice: {
    amount: number;
    currency: string;
  };
  fullPriceFormatted: string;
  duration: number;
  showVatInfo: boolean
}

export interface ActiveAddonExtension extends AbstractAddonExtension {
  autoRenew: true;
  activationDate: string;
}

export interface GameWorkerTask {
  task: GameWorkerTaskTypes;
  input: unknown;
}

export enum GameWorkerTaskTypes {
  GROUP_MODS = 'groupMods',
  FILTER_MODS_BY_QUERY = 'filterModsByQuery',
}

export interface GameserverPageData {
  useModsSpaceAddon: boolean;
}
